import { render, staticRenderFns } from "./receber-parcela-lote.vue?vue&type=template&id=6c9a21f9"
import script from "./receber-parcela-lote.vue?vue&type=script&lang=js"
export * from "./receber-parcela-lote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports